// ═══════════════════════════════════════════════
//   STAR CATCHER — minigame
// ═══════════════════════════════════════════════
//
// Objective:   Catch as many ⭐ supplies as possible without touching a 💣 bomb.
// Type:        catcher
// Description: Mouse/touch moves the basket left-right. Bombs arm once the
//              timer first drops below GAME_STARS.bombGraceSec and stay
//              armed for the rest of the round; touching one ends the round
//              with no pts but the score still posts to the leaderboard if
//              it's a personal best. ⏰ clocks add GAME_STARS.clockBonusSec
//              seconds when caught, so a skilled run can extend indefinitely.
//              Reward is per end-of-run score.
// Tunables:    GAME_STARS in data.js.

const {S, canvas, ctx, basket, claimGameReward, addCleanup, showGameOver} = window;

// ── Local runtime state ───────────────────────────────────────────────
window.stars = [];

function startStars() {
    const CFG = window.GAME_STARS;
    window.stars = [];
    window.gameTimer = CFG.timer;
    window.gameRunning = true;
    window.starsBombsArmed = false;
    basket.x = canvas.width / 2 - 35;
    document.getElementById('mg-timer').textContent = CFG.timer + 's';

    window.gameInterval = setInterval(starsLoop, 16);
    addCleanup(() => clearInterval(window.gameInterval));

    window.spawnInterval = setInterval(() => {
        if (!window.gameRunning) return;
        window.stars.push({
            x: Math.random() * (canvas.width - 30) + 15,
            y: -20,
            speed: CFG.starSpeedMin + Math.random() * (CFG.starSpeedMax - CFG.starSpeedMin),
            r: 12,
            type: 'star',
            color: ['#f72585', '#f5c842', '#7dd3fc', '#a8e063', '#ffb3d1'][Math.floor(Math.random() * 5)]
        });
        if (!window.starsBombsArmed && window.gameTimer < CFG.bombGraceSec) window.starsBombsArmed = true;
        if (window.starsBombsArmed && Math.random() < CFG.bombChance) {
            window.stars.push({
                x: Math.random() * (canvas.width - 30) + 15,
                y: -20,
                speed: 1 + Math.random() * 2,
                r: 12,
                type: 'bomb'
            });
        }
        if (Math.random() < CFG.clockChance) {
            window.stars.push({
                x: Math.random() * (canvas.width - 30) + 15,
                y: -20,
                speed: 1.2 + Math.random() * 1.3,
                r: 12,
                type: 'clock'
            });
        }
    }, CFG.spawnEvery);
    addCleanup(() => clearInterval(window.spawnInterval));

    window.timerInterval = setInterval(() => {
        window.gameTimer--;
        document.getElementById('mg-timer').textContent = window.gameTimer + 's';
        if (window.gameTimer <= 0) endStars();
    }, 1000);
    addCleanup(() => clearInterval(window.timerInterval));

    addCleanup(() => { window.stars = []; });
}

function starsLoop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#1a0010';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#f72585';
    ctx.beginPath();
    ctx.roundRect(basket.x, basket.y, basket.w, 16, 8);
    ctx.fill();
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;
    ctx.stroke();
    window.stars = window.stars.filter(s => {
        s.y += s.speed;
        if (s.type === 'star') {
            ctx.fillStyle = s.color;
            ctx.beginPath();
            ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
            ctx.fill();
            ctx.fillStyle = 'rgba(255,255,255,.4)';
            ctx.beginPath();
            ctx.arc(s.x - 3, s.y - 4, 4, 0, Math.PI * 2);
            ctx.fill();
        } else if (s.type === 'bomb') {
            ctx.font = '20px serif';
            ctx.textAlign = 'center';
            ctx.fillText('💣', s.x, s.y + 6);
        } else {
            ctx.font = '20px serif';
            ctx.textAlign = 'center';
            ctx.fillText('⏰', s.x, s.y + 6);
        }
        if (s.y + s.r > basket.y && s.y - s.r < basket.y + 16 && s.x > basket.x && s.x < basket.x + basket.w) {
            if (s.type === 'star') {
                window.gameScore++;
                document.getElementById('mg-score').textContent = window.gameScore;
                SFX.play('hit');
                return false;
            } else if (s.type === 'bomb') {
                SFX.play('damage');
                endStars(true);
                return false;
            } else {
                window.gameTimer += window.GAME_STARS.clockBonusSec;
                document.getElementById('mg-timer').textContent = window.gameTimer + 's';
                SFX.play('pts');
                return false;
            }
        }
        return s.y < canvas.height + 20;
    });
}

function endStars(bomb = false) {
    const CFG = window.GAME_STARS;
    window.gameRunning = false;
    if (!bomb) SFX.play(window.gameScore > 0 ? 'win' : 'gameover');
    if (window.gameScore >= CFG.nickThreshold) window.unlockNick('speedrunner');
    const p = Math.min(CFG.rewardMax, Math.floor(window.gameScore / CFG.rewardDivisor));
    let msg;
    if (bomb) {
        // Submit the score to the leaderboard (claimGameReward writes to
        // user_game_scores when isRecord) but pass maxPts=0 so no pts are paid.
        const prevTop = S.gameTopScores['stars'] ?? -1;
        claimGameReward('stars', window.gameScore, 0);
        const isRecord = window.gameScore > prevTop;
        msg = isRecord
            ? `BOOM! 💣 Stars: ${window.gameScore} — 🏆 NEW RECORD! (no pts for hitting a bomb)`
            : `BOOM! 💣 Stars: ${window.gameScore} — no pts for hitting a bomb!`;
    } else {
        msg = claimGameReward('stars', window.gameScore, p);
    }
    showGameOver(msg);
}

// Module-level basket controls — kept attached across rounds so stopGame()
// doesn't need to wire them. Both guard via S.currentGame so they're
// harmless when other games run on the shared canvas.
canvas.addEventListener('mousemove', e => {
    if (!window.gameRunning || S.currentGame !== 'stars') return;
    basket.x = canvasPos(e).x - basket.w / 2;
});
canvas.addEventListener('touchmove', e => {
    if (!window.gameRunning || S.currentGame !== 'stars') return;
    e.preventDefault();
    basket.x = canvasPos(e).x - basket.w / 2;
}, {passive: false});

window.startStars = startStars;
window.starsLoop = starsLoop;
window.endStars = endStars;
